import { AppState } from '../../root-reducer';

export const selectFavouriteMaps = (state: AppState) => state.favouritesDomain.likedMaps;
